import { Controller } from "@hotwired/stimulus"

// Slides the active pill highlight when Bootstrap tabs change (iOS / switch style).
export default class extends Controller {
  static targets = ["indicator"]

  connect() {
    this.onTabShown = this.onTabShown.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onDocumentTabShown = this.onDocumentTabShown.bind(this)

    this.element.addEventListener("shown.bs.tab", this.onTabShown)
    document.addEventListener("shown.bs.tab", this.onDocumentTabShown)
    window.addEventListener("resize", this.onResize)
    this.element.addEventListener("scroll", this.onScroll, { passive: true })

    this.resizeObserver = new ResizeObserver(() => this.refreshIndicator())
    this.resizeObserver.observe(this.element)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.moveIndicator(this.activeTab()))
    })
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.onTabShown)
    document.removeEventListener("shown.bs.tab", this.onDocumentTabShown)
    window.removeEventListener("resize", this.onResize)
    this.element.removeEventListener("scroll", this.onScroll)
    this.resizeObserver?.disconnect()
  }

  onTabShown(event) {
    const tab = event.target?.classList?.contains("nav-link") ? event.target : this.activeTab()
    this.moveIndicator(tab)
  }

  onResize() {
    this.moveIndicator(this.activeTab())
  }

  onScroll() {
    this.moveIndicator(this.activeTab())
  }

  // Nested pill toggles (e.g. row layout in a hub tab pane) mount while `display: none`;
  // reposition when the parent Bootstrap tab becomes visible.
  onDocumentTabShown(event) {
    const paneId = event.target?.getAttribute?.("aria-controls")
    if (!paneId) return

    const pane = document.getElementById(paneId)
    if (pane?.contains(this.element)) this.refreshIndicator()
  }

  activeTab() {
    return this.element.querySelector(".nav-link.active")
  }

  moveIndicator(tab, attempt = 0) {
    if (!this.hasIndicatorTarget) return

    if (!tab) {
      this.indicatorTarget.classList.remove("is-ready")
      return
    }

    const item = tab.closest(".nav-item") || tab
    const width = item.offsetWidth

    if (width === 0) {
      this.indicatorTarget.classList.remove("is-ready")

      if (attempt < 8) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.moveIndicator(this.activeTab(), attempt + 1))
        })
      }

      return
    }

    this.indicatorTarget.style.width = `${width}px`
    this.indicatorTarget.style.transform = `translateX(${item.offsetLeft}px)`
    this.indicatorTarget.classList.add("is-ready")
  }

  refreshIndicator() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.moveIndicator(this.activeTab()))
    })
  }
}
